<template>
    <div class="flex flex-col gap-8">
        <FormGroup :label="$t('forms.company_relationship.company_relationship_properties_form.primary_company')" :error-text="form.errors?.primary_company_id">
            <Dropdown
                v-model="form.primary_company_id"
                :options="availableCompanies"
                option-label="name"
                option-value="id"
                @change="form.validate('primary_company_id')"
                :placeholder="$t('common.na')"
                show-clear
            />
        </FormGroup>

        <FormGroup :label="$t('forms.company_relationship.company_relationship_properties_form.secondary_company')" :error-text="form.errors?.secondary_company_id">
            <Dropdown
                v-model="form.secondary_company_id"
                :options="availableCompanies"
                option-label="name"
                option-value="id"
                @change="form.validate('secondary_company_id')"
                :placeholder="$t('common.na')"
                show-clear
            />
        </FormGroup>

        <FormGroup :label="$t('forms.company_relationship.company_relationship_properties_form.relationship_type')" :error-text="form.errors?.relationship_type">
            <Dropdown
                v-model="form.relationship_type"
                :options="relationshipTypeOptions"
                option-label="label"
                option-value="value"
                @change="form.validate('relationship_type')"
                :placeholder="$t('common.na')"
            />
        </FormGroup>
    </div>

    <template v-if="hasOnSaveListener">
        <div class="flex justify-end space-x-3 mt-8">
            <Button
                class="px-8"
                :label="$t('forms.common.save')"
                v-if="hasOnSaveListener && !disabled"
                @click="$emit('on-save', form)"
                :disabled="form.processing"
            />
        </div>
    </template>
</template>

<script>
import FormGroup from "@/Components/FormGroup.vue";

export default {
    name: "CompanyRelationshipPropertiesForm",
    components: { FormGroup },
    props: {
        disabled: {
            type: Boolean,
            default: false,
        },
        form: {
            type: Object,
            required: true,
        },
        availableCompanies: {
            type: Array,
            required: true,
        },
    },
    computed: {
        hasOnSaveListener() {
            return !!(this.$attrs?.onOnSave);
        },
        hasOnDeleteListener() {
            return !!(this.$attrs?.onOnDelete);
        },
        relationshipTypeOptions() {
            return [
                {
                    label: this.$t('forms.company_relationship.company_relationship_properties_form.relationship_type_component_supplier'),
                    value: 'component_supplier',
                },
            ];
        },
    },
};
</script>

<style scoped>
</style>
